import Breadcrumbs from 'components/breadcrumbs/Breadcrumbs';
import { getCurrentDetailCrumbs } from 'components/view/utils/view';

import { Box } from '@mui/material';

import { Crumb } from './Crumb';
import { useDetailInfo } from 'contexts/DetailContext';

const DetailBreadcrumbs = () => {
  const {id, detail, label} = useDetailInfo() || {}
  const crumbs = getCurrentDetailCrumbs(detail, id)

  if (crumbs.length > 0) {
    crumbs[crumbs.length -1].label = label
  } else {
    crumbs.push({label: label})
  }

  return (
    <Box sx={{padding: "15px", display: "flex", flexDirection: "row", alignItems: "center"}}>
      <Crumbs crumbs={crumbs}/>
    </Box>
  )
}
  
const Crumbs = ({crumbs}: {crumbs: Crumb[]}) => 
  crumbs.length > 0 ? <Breadcrumbs crumbs={crumbs} /> : null


export default DetailBreadcrumbs
